var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"w-100 pa-2"},[_c('v-list-item-content',{staticClass:"pa-0"},[_c('v-list-item-subtitle',{staticClass:"text-start"},[_vm._v(_vm._s(_vm.title))]),_c('v-list-item-title',{staticClass:"headline mb-1 text-center text-size d-flex justify-center"},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }